import { TApplicationState } from 'shared/types/redux';

export function getOpenedPhones(state: TApplicationState) {
  return state.phones.openedPhones;
}
